import { Theme } from '@mui/material/styles'
import { useGetUserVenueQuery } from '__generated__/types'
import { findTheme } from 'apps/Diner/styles'
import { useDinerLocation } from 'apps/Diner/contexts/DinerLocation/DinerLocationContext'

const useDynamicTheme = ({
  merchantLocationId,
  venueId
}: {
  merchantLocationId?: string | string[]
  venueId?: string | string[]
}): Theme => {
  const { merchantLocation } = useDinerLocation()

  // NOTE: If merchantLocationId is present, it overrides venueId
  const { data: venueData } = useGetUserVenueQuery({
    variables: {
      venueId
    },
    skip: !venueId || !merchantLocationId
  })
  const venue = venueData?.venue

  return findTheme(merchantLocation?.theme || venue?.theme)
}

export default useDynamicTheme
